import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recruitmentFeaturedProfilesSelector } from '../selectors';
import { actions as RecruitmentActions } from '../modules';
import apiService from '../../../services/apiService';

const useFeaturedRecruitmentProfiles = (region: string) => {
  const dispatch = useDispatch();
  const featuredProfiles = useSelector(recruitmentFeaturedProfilesSelector);

  useEffect(() => {
    if (featuredProfiles.loaded || featuredProfiles.loading) {
      return;
    }

    const loadQueryParams: any = {
      limit: 10,
      region
    };

    dispatch(RecruitmentActions.loadFeaturedProfiles());

    apiService.getFeaturedRecruitmentProfiles(loadQueryParams, (err, data) => {
      if (err) {
        dispatch(RecruitmentActions.loadFeaturedProfilesFailure());
      } else {
        dispatch(RecruitmentActions.loadFeaturedProfilesSuccess(data.profiles));
      }
    });
  }, [featuredProfiles]);

  return featuredProfiles;
};

export default useFeaturedRecruitmentProfiles;
